import React from "react";

const PromoRadioCheckedIcon = props => (
  <svg width={24} height={24} {...props}>
    <rect
      x={21}
      y={11}
      width={16}
      height={16}
      rx={24}
      transform="translate(-17 -7)"
      fill="#6DC7C3"
      stroke="#FFF"
      strokeWidth={8}
      fillRule="evenodd"
    />
  </svg>
);

export default PromoRadioCheckedIcon;


// WEBPACK FOOTER //
// ./src/components/CRM/Form/Icons/PromoRadioChecked.js